module.exports = __webpack_public_path__ + "img/cornovii-l.769d4189.jpg";